import * as React from "react";
import { useState, useMemo } from "react";
import styled from "styled-components";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import BootstrapModalConfirm from "components/bootstrap/BootstrapModalConfirm";
import { Label } from "components/bootstrap";
import { Icon } from "components/common";
import Routes from "routing/Routes";
import { useRemoveEvidence } from "security-app/hooks/useInvestigationsAPI";
import useHistory from "routing/useHistory";
import DashboardsModal from "./DashboardsModal";
import { IconButton, StyledLink } from "../styled.components";
const DashboardRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 1rem 0;
`;
const DashboardEvidenceList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  padding-right: 1rem;
`;
const StyledIconButton = styled(IconButton)`
  padding: 0;
`;
const StyledLabel = styled(Label)`
  display: flex;
  flex-direction: row;
  height: 24px;
  gap: 0.4rem;
`;
function Dashboards({ investigation }) {
  const { permissions } = useCurrentUser();
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteDashboardId, setDeleteDashboardId] = useState(null);
  const history = useHistory();
  const canManageEvidence = useMemo(
    () => !investigation.archived && isPermitted(permissions, "investigations:edit"),
    [investigation.archived, permissions]
  );
  const { removeEvidence, removingEvidence } = useRemoveEvidence();
  const removeDashboard = async () => {
    await removeEvidence({ invId: investigation.id, payload: { dashboards: [deleteDashboardId] } });
    setShowDeleteDialog(false);
    setDeleteDashboardId(null);
  };
  const onDelete = (dashboardId) => (e) => {
    e.stopPropagation();
    setShowDeleteDialog(true);
    setDeleteDashboardId(dashboardId);
  };
  const onCancelDelete = () => {
    setShowDeleteDialog(false);
    setDeleteDashboardId(null);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DashboardRow, null, /* @__PURE__ */ React.createElement("h2", { style: { marginRight: "1rem" } }, "Dashboards"), investigation.dashboards.length > 0 && /* @__PURE__ */ React.createElement(DashboardEvidenceList, null, investigation.dashboards.map((dashboard) => /* @__PURE__ */ React.createElement(StyledLabel, { key: dashboard.id }, /* @__PURE__ */ React.createElement(StyledLink, { onClick: () => history.push(Routes.VIEWS.VIEWID(dashboard.id)) }, dashboard.title), canManageEvidence && /* @__PURE__ */ React.createElement(
    StyledIconButton,
    {
      $danger: true,
      "aria-label": `Delete dashboard ${dashboard.title}`,
      onClick: onDelete(dashboard.id)
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "close" })
  )))), /* @__PURE__ */ React.createElement(StyledLabel, null, /* @__PURE__ */ React.createElement(StyledIconButton, { "aria-label": "Add dashboard", onClick: () => setShowAddModal(true) }, /* @__PURE__ */ React.createElement(Icon, { name: "add" })))), /* @__PURE__ */ React.createElement(DashboardsModal, { show: showAddModal, onCancel: () => setShowAddModal(false) }), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showDeleteDialog,
      title: "Delete Dashboard",
      onConfirm: removeDashboard,
      onCancel: onCancelDelete,
      confirmButtonDisabled: removingEvidence
    },
    "Are you sure you want to delete this Dashboard?"
  ));
}
export default Dashboards;
